import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
export function PurchaseSection() {
  return <section id="purchase-section" className="bg-brand-black px-4 py-20 sm:px-6 lg:px-8 border-t border-white/10 scroll-mt-10" data-id="element-120">
      <div className="mx-auto max-w-5xl" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <div className="mb-4 h-1 w-24 bg-brand-green mx-auto" data-id="element-123"></div>
          <h2 className="mb-8 text-3xl font-bold text-white sm:text-4xl" data-id="element-124">
            La decisión es simple:
          </h2>

          <div className="grid gap-6 md:grid-cols-2 text-left max-w-4xl mx-auto mb-12" data-id="element-125">
            <div className="bg-white/5 p-6 rounded-xl border border-white/10" data-id="element-126">
              <h3 className="text-xl font-bold text-gray-400 mb-3" data-id="element-127">
                Opción A:
              </h3>
              <p className="text-gray-300" data-id="element-128">
                Seguir improvisando cada chat, bajando precios, persiguiendo
                clientes y cerrando el 20% de lo que podrías cerrar.
              </p>
            </div>
            <div className="bg-brand-green/10 p-6 rounded-xl border border-brand-green/30" data-id="element-129">
              <h3 className="text-xl font-bold text-brand-green mb-3" data-id="element-130">
                Opción B:
              </h3>
              <p className="text-white" data-id="element-131">
                Invertir hoy, aplicar el sistema esta semana y cambiar
                permanentemente tus resultados en WhatsApp.
              </p>
            </div>
          </div>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto italic" data-id="element-132">
            Por el precio de una comida rápida, adquieres la habilidad que
            sostiene cualquier negocio:{' '}
            <strong className="text-white" data-id="element-133">
              saber convertir conversaciones en dinero.
            </strong>
          </p>
        </div>

        {/* Pricing Cards Container */}
        <div className="grid gap-8 md:grid-cols-2 items-stretch" data-id="element-134">
          {/* Standard Offer */}
          <div className="flex flex-col rounded-2xl border border-gray-700 bg-brand-darkGray p-8 relative" data-id="element-135">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-136">CIERRE 2.0</h3>
            <p className="text-gray-400 mb-6" data-id="element-137">
              El sistema base completo + 3 Bonos
            </p>

            <div className="mb-8" data-id="element-138">
              <span className="text-5xl font-black text-white" data-id="element-139">$13.99</span>
              <span className="text-gray-500 line-through ml-3" data-id="element-140">$176.00</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-141">
              <li className="flex items-start gap-3" data-id="element-142">
                <CheckCircle2Icon className="h-5 w-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-143" />
                <span className="text-gray-300" data-id="element-144">Los 5 Tomos del Sistema</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-145">
                <CheckCircle2Icon className="h-5 w-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-146" />
                <span className="text-gray-300" data-id="element-147">
                  Bono 1: Diagnóstico Anti-Visto
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-148">
                <CheckCircle2Icon className="h-5 w-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-149" />
                <span className="text-gray-300" data-id="element-150">
                  Bono 2: Oferta Irresistible
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-151">
                <CheckCircle2Icon className="h-5 w-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-152" />
                <span className="text-gray-300" data-id="element-153">
                  Bono 3: Banco de Prueba Social
                </span>
              </li>
            </ul>

            <CTAButton href="https://pagos.digipromarket.com/cart/56249675841862:1" fullWidth className="bg-white text-brand-black hover:bg-gray-200 shadow-none hover:shadow-none" data-id="element-154">
              COMPRAR POR $13.99
            </CTAButton>
          </div>

          {/* Upsell Offer */}
          <div className="flex flex-col rounded-2xl border-2 border-brand-green bg-brand-darkGray p-8 relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(37,211,102,0.15)]" data-id="element-155">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-green text-brand-black font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 whitespace-nowrap" data-id="element-156">
              <ZapIcon className="h-4 w-4" data-id="element-157" /> RECOMENDADO
            </div>

            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-158">
              CIERRE 2.0 + VIP
            </h3>
            <p className="text-brand-green mb-6 font-medium" data-id="element-159">
              Todo lo anterior + Aceleradores
            </p>

            <div className="mb-8" data-id="element-160">
              <span className="text-5xl font-black text-brand-green" data-id="element-161">
                $19.99
              </span>
              <span className="text-gray-500 line-through ml-3" data-id="element-162">$223.00</span>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-163">
              <li className="flex items-start gap-3" data-id="element-164">
                <CheckCircle2Icon className="h-5 w-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-165" />
                <span className="text-white font-medium" data-id="element-166">
                  Todo lo incluido en Cierre 2.0
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-167">
                <CheckCircle2Icon className="h-5 w-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-168" />
                <span className="text-gray-300" data-id="element-169">
                  <strong className="text-brand-gold" data-id="element-170">VIP:</strong> 50
                  Plantillas Copy & Paste
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-171">
                <CheckCircle2Icon className="h-5 w-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-172" />
                <span className="text-gray-300" data-id="element-173">
                  <strong className="text-brand-gold" data-id="element-174">VIP:</strong>{' '}
                  Audio-entrenamiento (MP3)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-175">
                <CheckCircle2Icon className="h-5 w-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-176" />
                <span className="text-gray-300" data-id="element-177">
                  <strong className="text-brand-gold" data-id="element-178">VIP:</strong> Guía de
                  Manejo de Objeciones
                </span>
              </li>
            </ul>

            <CTAButton href="https://pagos.digipromarket.com/cart/56249694290246:1" fullWidth data-id="element-179">
              SÍ, QUIERO EL PAQUETE VIP
            </CTAButton>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-180">
          <p className="text-sm text-gray-500 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-181">
            <span data-id="element-182">⚡ Acceso inmediato</span>
            <span className="hidden sm:inline" data-id="element-183">•</span>
            <span data-id="element-184">PDF descargable</span>
            <span className="hidden sm:inline" data-id="element-185">•</span>
            <span data-id="element-186">Garantía 7 días</span>
            <span className="hidden sm:inline" data-id="element-187">•</span>
            <span data-id="element-188">Pago 100% Seguro</span>
          </p>
        </div>
      </div>
    </section>;
}